import React from 'react';
import '../Css/Portfolio.css'
import logo from '../images/computerMart.png'
import logo1 from '../images/sunnah.png'
import logo2 from '../images/wahiDental.png'
import { BiLinkExternal } from "@react-icons/all-files/bi/BiLinkExternal";
import { FaGithub } from '@react-icons/all-files/fa/FaGithub';

const Portfolio = () => {
    return (
     <>
     <div className='lg:mt-60 mt-20 pb-10' id='portfolio'>
        <div className='portfolio-title  ' id='portfolio'>
            <h1 className='bg-slate-700  inline-block font-bold lg:text-2xl p-2 rounded-lg '>portfolio</h1>
        </div>
        <div className='portfolio-section'>

            <div>
            <div class="card  bg-slate-700 shadow-xl">
  <figure><img src={logo} alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-2xl font-bold">Computer Mart</h2>
    <p className='text-xl'>This website sells computer parts. It has admin and
users role. It has a stripe payment method.
</p>
<div className='flex gap-x-3 mt-2'>
 <a href="https://github.com/borhansahed/computer-mart-client" target="blank"><FaGithub className='text-2xl'></FaGithub></a>
 <a href="https://computer-mart-fb654.web.app/" target="blank"><BiLinkExternal className='text-2xl'> </BiLinkExternal></a>
</div>
    <h4 className='text-base lg:mt-3'>react  nodejs  mongoDB  expressjs  </h4>
  </div>
</div>
            </div>
            <div>
            <div class="card   bg-slate-700 shadow-xl">
  <figure><img src={logo1} alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="text-2xl font-bold">Sunnah Furniture</h2>
    <p className='text-xl'>A full-stack website of a warehouse of Furniture items. Users can create an account.
 </p>
    <div className='flex gap-x-3 mt-2'>
 <a href="https://github.com/borhansahed/sunnah-furniture-warehouse" target="blank"><FaGithub className='text-2xl'></FaGithub></a>
 <a href="https://warehouse-25088.web.app/" target="blank"><BiLinkExternal className='text-2xl'> </BiLinkExternal></a>
</div>
    <h4 className='text-base lg:mt-3'>react  nodejs  mongoDB  expressjs  </h4>
  </div>
</div>
            </div>
            <div>
            <div class="card  bg-slate-700 shadow-xl">
  <figure><img src={logo2}/></figure>
  <div class="card-body">
    <h2 class="text-2xl font-bold">Wahi Dental Studio</h2>
    <p className='text-xl'>Dental studio website for teeth patients. Patients can
purchase they are treatment.</p>
    <div className='flex gap-x-3 mt-2'>
 <a href="https://github.com/borhansahed/wahi-dental" target="blank"><FaGithub className='text-2xl'></FaGithub></a>
 <a href="https://wahi-dental-studio.web.app/" target="blank"><BiLinkExternal className='text-2xl'> </BiLinkExternal></a>
</div>
    <h4 className='text-base lg:mt-3 '>react  firebase  </h4>
  </div>
</div>
            </div>
        </div>
        <p className='text-center mt-10 lg:mt-14 lg:ml-52 '><a className='portfolio-button lg:text-xl ' href="https://github.com/borhansahed?tab=repositories" target="blank">More</a> </p>
     </div>
     </>
    );
};

export default Portfolio;